<template>
  <div class="container">
    <div class="sort-wrap ub ub-pj px-1">
      <span :class="[auditStatus==-1&&postStatus==-1?'active':'']" @click="toChangeSort(-1)">全部</span>
      <span :class="[auditStatus==0&&postStatus==1?'active':'']" @click="toChangeSort(0)">审核中</span>
      <span :class="[auditStatus==1&&postStatus==1?'active':'']" @click="toChangeSort(1)">已通过</span>
      <span :class="[auditStatus==2&&postStatus==1?'active':'']" @click="toChangeSort(2)">未通过</span>
      <span :class="[postStatus==0?'active':'']" @click="toChangePublic(0)">草稿</span>
    </div>

    <div class="scroll-wrap">
      <el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="文章" name="0">
          <div v-if="dataList.length>0">
            <div v-for="(item,index) in dataList" :key="index">
              <PublicItem :item="item" :activeTab="activeTab" @toDelete="toDelete"/>
            </div>
          </div>
          <Empty v-else content="暂无内容"/>
          <span v-if="dataList.length<1" class="public-btn btn-fb" @click="toPublic('article')">立即发布</span>
        </el-tab-pane>
        <el-tab-pane label="视频" name="2">
          <div v-if="dataList.length>0">
            <div v-for="(item,index) in dataList" :key="index">
              <PublicItem :item="item" :activeTab="activeTab" @toDelete="toDelete"/>
            </div>
          </div>
          <Empty v-else content="暂无内容"/>
          <span v-if="dataList.length<1" class="public-btn btn-fb" @click="toPublic('video')">立即发布</span>
        </el-tab-pane>
        <el-tab-pane label="动态" name="1">
          <div v-if="dataList.length>0">
            <div v-for="(item,index) in dataList" :key="index">
              <PublicItem :isAsync="true" :item="item" :activeTab="activeTab" @toDelete="toDelete"/>
            </div>
          </div>
          <Empty v-else content="暂无内容"/>
          <span v-if="dataList.length<1" class="public-btn btn-fb" @click="toPublic('trends')">立即发布</span>
        </el-tab-pane>
        <el-tab-pane label="优化建议" name="3">
          <div v-if="dataList.length>0">
            <div v-for="(item,index) in dataList" :key="index">
              <PublicItem :isAsync="true" :item="item" :activeTab="activeTab" @toDelete="toDelete"/>
            </div>
          </div>
          <Empty v-else content="暂无内容"/>
          <span v-if="dataList.length<1" class="public-btn btn-fb" @click="toPublic('optimize')">立即发布</span>
        </el-tab-pane>
        <el-tab-pane label="问答" name="4">
          <div v-if="dataList.length>0">
            <div v-for="(item,index) in dataList" :key="index">
              <PublicItem :isAsync="true" :item="item" :activeTab="activeTab" @toDelete="toDelete"/>
            </div>
          </div>
          <Empty v-else content="暂无内容"/>
          <span v-if="dataList.length<1" class="public-btn btn-fb" @click="toPublic('question')">立即发布</span>
        </el-tab-pane>
        <el-tab-pane label="反馈" name="5">
          <div v-if="dataList.length>0">
            <div v-for="(item,index) in dataList" :key="index">
              <PublicItem :isAsync="true" :item="item" :activeTab="activeTab" @toDelete="toDelete"/>
            </div>
          </div>
          <Empty v-else content="暂无内容"/>
          <span v-if="dataList.length<1" class="public-btn btn-fb" @click="toPublic('bug')">立即发布</span>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div  class="pagination-bar">
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="Number(total)"
          :current-page="pageNum"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog style="z-index: 9999999;" title="发表动态" :visible.sync="feedDialog" width="1000px" append-to-body destroy-on-close :close-on-click-modal="false">
      <div class="dialog-wrap">
        <PublicTrends @toCancel="toCancel"/>
      </div>
    </el-dialog>
    <el-dialog style="z-index: 9999999;" title="发布建议" :visible.sync="feedDialogoptimize" width="1000px" append-to-body destroy-on-close :close-on-click-modal="false">
      <div class="dialog-wrap">
        <PublicQuestion :postType = "3" @toCancel="feedDialogoptimize = false"/>
      </div>
    </el-dialog>
    <el-dialog style="z-index: 9999999;" title="发布问题" :visible.sync="feedDialogQuestion" width="1000px" append-to-body destroy-on-close :close-on-click-modal="false">
      <div class="dialog-wrap">
        <PublicQuestion :postType = "4" @toCancel="feedDialogQuestion = false"/>
      </div>
    </el-dialog>
    <el-dialog style="z-index: 9999999;" title="发布Bug反馈" :visible.sync="feedDialogBug" width="1000px" append-to-body destroy-on-close :close-on-click-modal="false">
      <div class="dialog-wrap">
        <PublicBug :postType = "5" @toCancel="feedDialogBug = false"/>
      </div>
    </el-dialog>
  </div>
</template>

  <script>
    import Empty from '@/components/empty'
    import PublicItem from '@/components/public/publicItem'
    import qs from 'qs'
    import { post,ajaxParam } from '@/units/request.js'
    import PublicTrends from '@/components/public/publicTrends'
    import PublicQuestion from '@/components/public/publicQuestion'
    import PublicBug from '@/components/public/publicBug'
    export default {
      name: 'publicManage',
      components: {
        PublicItem,
        Empty,
        PublicTrends,
        PublicQuestion,
        PublicBug
      },
      data(){
        return{
          activeTab: '0',
          auditStatus: -1, //-1 全部 0未审核 1已通过 2未通过  默认已通过
          postType: 0,  //0文字  1图片 2视频
          postStatus: -1, //默认是发布  0草稿  1发布
          pageNum: 1,
          pageSize: 5,
          dataList: [],
          total: 0,
          feedDialog: false,
          feedDialogoptimize: false,
          feedDialogQuestion: false,
          feedDialogBug: false
        }
      },
      created(){
        this.userId = localStorage.getItem('userId')||''
        this.getDataList()
      },
      methods: {
        //获取发布帖子
        async getDataList(){
          let param = {
            userId: this.userId,
            addUserId: this.userId,
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            auditStatus: this.auditStatus,
            postType: this.postType,
            postStatus: this.postStatus
          }
          ajaxParam(param)
          const res = await post('v1/circle/userPostList', qs.stringify(param))
          if(res.data.code==200){
            this.dataList = res.data.list
            this.total = res.data.total
            // console.log('postList:',this.dataList,'total:',this.total)
          } else {
            this.$message.error(res.data.msg)
          }
        },
        toChangeSort(num){
          console.log(num)
          this.auditStatus = num
          if(num==-1){
            this.postStatus = -1
          }else{
            this.postStatus = 1
          }
          this.dataList = []
          this.pageNum = 1
          this.getDataList()
        },
        toChangePublic(num){
          this.postStatus = num
          this.auditStatus ='-1'
          this.dataList = []
          this.pageNum = 1
          this.getDataList()
        },
        handleCurrentChange(page){
          this.dataList = []
          this.pageNum = page
          this.getDataList()
        },
        handleClick(tab, event) {
          console.log(tab.name)
          let name = tab.name
          this.postType = name
          this.dataList = []
          this.pageNum = 1
          this.getDataList()
        },
        //删除帖子
        toDelete(e){
          let id = e.postId
          this.$confirm('确定要删除该帖子吗？','温馨提示',{
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(async()=>{
              let param = {
                userId: this.userId,
                postId: id
              }
              ajaxParam(param)
              const res = await post('v1/circle/deletePost', qs.stringify(param))
              if(res.data.code==200){
                this.$message.success('删除成功！')
              this.dataList.forEach((item,index)=>{
                if(item.id==id){
                  this.dataList.splice(index,1)
                }
              })
              } else {
                this.$message.error(res.data.msg)
              }
          }).catch(()=>{

          })

        },
        toCancel(){
          this.feedDialog = false
        },
        //跳转到发布
        toPublic(e){
          let path = this.userId?'/public':'/login'
          if(e=='trends') {
          // 动态
            this.feedDialog = true
          }else if(e=='optimize') {
            // 优化建议
            this.feedDialogoptimize = true
          } else if(e=='question') {
          // 问题
            this.feedDialogQuestion = true
          } else if(e=='bug') {
          // bug反馈
            this.feedDialogBug = true
          } else {
            this.$router.push({
              path: path,
              query: {
                type: e
              }
            })
          }
        },
      }
    }
  </script>

  <style lang="less" scoped>
   .container {
     position: relative;
     background: #fff;
     padding: 20px;
     height: 100dvh; /* 手机兼容 */
     display: flex;
     flex-direction: column;
     overflow: hidden;

     /* 右上角排序栏 */
     .sort-wrap {
       position: absolute;
       right: 40px;
       top: 10px;
       width: 260px;
       height: 32px;
       background: #F3F4F7;
       border-radius: 4px;
       z-index: 999;

       span {
         display: block;
         height: 28px;
         padding: 0 5px;
         border-radius: 4px;
         text-align: center;
         line-height: 28px;
         cursor: pointer;
         font-size: 12px;

         &.active {
           background: #fff;
         }
       }
     }

     /* 内容滚动区域 */
     .scroll-wrap {
       flex: 1;
       overflow-y: auto;
       box-sizing: border-box;
     }

     .pagination-bar{
      flex: 0 0 auto;
      background: #fff;
      padding-top: 10px;
    }

     /* Tabs 样式 */
     /deep/ .el-tabs__item {
       height: 42px;
       line-height: 42px;
       font-size: 14px;
     }
     /deep/ .el-tabs__content {
       padding: 10px 0;
     }

     .pagination-wrap{
       display: flex;
       justify-content: center;
       margin: 30px 0 0;
     }
     /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
       background-color: var(--color-text-a);
       color: #fff;
     }
     /deep/ .el-pagination.is-background .el-pager li:hover{
       color: var(--color-text-a)
     }

     /* 空状态样式 */
     .empty {
       display: flex;
       flex-direction: column;
       justify-content: center;
       align-items: center;
       width: 260px;
       margin: 60px auto;

       img {
         width: 260px;
         height: 230px;
       }
       span {
         padding: 20px 0 30px;
         color: var(--color-text-opacity);
       }
     }

     /* 发布按钮 */
     .public-btn {
       display: flex;
       width: 69px;
       justify-content: center;
       align-items: center;
       background: #DD0515;
       cursor: pointer;
       margin: 20px auto;

       &.btn-fb {
         border-radius: 20px;
         color: #fff;
         font-size: 12px;
         height: 30px;
         line-height: 30px;
         padding: 0 20px;
         width: auto;
       }
     }

     /* 弹窗样式 */
     .dialog-wrap {
       padding: 0;
       margin: 0;
     }
   }
  </style>
